import React from 'react';
import { Box, Drawer, styled } from '@mui/material';
// ------------------------------------------------------------------
const Wrapper = styled(Box)(({ theme }) => ({
    height: `100%`,
    width: `inherit`,
    position: `fixed`,
    overflow: `clip`,
    display: `flex`,
    flexDirection: `column`,
    boxShadow: theme.shadows[1],
    zIndex: theme.zIndex.drawer + 3,
}));

interface LayoutDrawerProps {
    children: React.ReactNode;
    open: boolean;
    onClose: () => void;
    drawerWidth?: number;
}

const LayoutDrawer: React.FC<LayoutDrawerProps> = props => {
    const { children, open, onClose, drawerWidth = 280 } = props;
    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: drawerWidth,
                },
            }}
        >
            <Wrapper>{children}</Wrapper>
        </Drawer>
    );
};

export default LayoutDrawer;
